module.exports = __webpack_public_path__ + "static/media/keppel.33488412.png";